export default {
	subTitle: "Settings",
	pageTitle: "Memberships",
};
